import React from 'react';
import i18next from 'i18next';
import { Box, Grid, Container, Typography } from '@mui/material';
import DeviceBreakPoints from '../../../deviceBreakPoints';
import styles from './how-it-works.module.scss';

const buyerSteps = (subHeader) => {
  const { isMediumDevice } = DeviceBreakPoints();
  return (
    <Grid container>
      {Array.isArray(subHeader) &&
        subHeader.map((subHeaderText, index) => (
          <Grid item xs sm md lg xl key={index}>
            <Box className={styles['number-bold-font']}>
              <Typography variant='boldOnlyText' align='center' paddingLeft={'1rem'}>
                {index + 1}.
              </Typography>
            </Box>
            <Box>
              <Typography
                variant='body1'
                paddingLeft={'1rem'}
                align='center'
                fontSize={isMediumDevice ? '0.75rem' : '1rem'}
              >
                {subHeaderText}
              </Typography>
            </Box>
          </Grid>
        ))}
    </Grid>
  );
};

const elementBlockToDisplay = (value, subHeader, image) => {
  const { theme } = DeviceBreakPoints();
  return (
    <Box
      className={styles['diagonal-bg']}
      sx={{
        backgroundImage: theme.palette.primaryBackground.main,
        color: 'common.light',
        backgroundColor: theme.palette.primaryBackground.main
      }}
    >
      <Box my={2} textAlign='center'>
        <Box component='span' className={styles['initial-bold-font']}>
          <Typography variant='h6' component='boldText' sx={{ fontSize: '1.8rem' }}>
            {i18next.t('HOME_PAGE.CUSTOMER_JOURNEY.HOW_IT_WORKS')}
          </Typography>
        </Box>
      </Box>
      <Box
        textAlign='center'
        mt={6}
        mx={value === 'apply-margin'}
        className={styles['stepper-text']}
      >
        {buyerSteps(subHeader)}
      </Box>
      <Box textAlign='center'>
        <Box
          component='img'
          src={image}
          alt={i18next.t('IMAGE_ALT_TEXT.CAMPAIGN_SECTION.BUYER_STEPPER')}
          className={styles['buyer-stepper']}
        />
      </Box>
    </Box>
  );
};

function HowItWorks({ header, subHeader, image }) {
  const { theme } = DeviceBreakPoints();
  return (
    <>
      <Box
        display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}
      >
        <Box
          className={styles['diagonal-bg']}
          sx={{
            backgroundImage: theme.palette.primaryBackground.main,
            color: 'common.light',
            backgroundColor: theme.palette.primaryBackground.main
          }}
        >
          <Container>
            <Box textAlign='center' py={3}>
              <Typography variant='boldText' className={styles['initial-bold-font']}>
                {header}
              </Typography>
            </Box>
            <Grid container className={styles['upper-section-wrapper']}>
              <Grid
                item
                xs
                sm
                md={6}
                lg={6}
                xl={6}
                className={styles['step-section-wrapper']}
              >
                {buyerSteps(subHeader)}
                <Box
                  component='img'
                  src={image}
                  alt={i18next.t('IMAGE_ALT_TEXT.CAMPAIGN_SECTION.BUYER_STEPPER')}
                  className={styles['buyer-stepper']}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
      <Box display={{ xs: 'none', sm: 'block', md: 'none', lg: 'none', xl: 'none' }}>
        {elementBlockToDisplay('', subHeader, image)}
      </Box>
      <Box display={{ xs: 'block', sm: 'none', md: 'none', lg: 'none', xl: 'none' }}>
        {elementBlockToDisplay('apply-margin', subHeader, image)}
      </Box>
    </>
  );
}

export default HowItWorks;
